/**
 * §3.2's wedstrijdboekjes: the documents JBNL publishes per seizoen, and their versions.
 * JBNL's own words: a <em>versie</em>, never the code's "generatie", which no boekje prints.
 */
export const wedstrijdboekjes = {
  lijst: {
    label: "Wedstrijdboekjes",
    zoek: "Zoek op naam",
    leeg: "Nog geen wedstrijdboekje in dit seizoen.",
    kies: "Kies een wedstrijdboekje om het af te drukken of aan te passen.",
    terug: "Terug naar de lijst",
    toevoegen: "Wedstrijdboekje toevoegen",
    submitToevoegen: "Toevoegen",
    aanSeizoen: "In seizoen {{naam}}.",
    naam: "Wedstrijdboekje",
    versies: "Versies",
    geenVersies: "Nog geen versie",
    filterVersies: "Alleen zonder versie",
  },

  ongedekt: {
    /** What ticking costs, and why this line is here (ADR-0036). */
    titel_one: "1 wedstrijddag staat in geen enkel wedstrijdboekje.",
    titel_other:
      "{{count}} wedstrijddagen staan in geen enkel wedstrijdboekje.",
    uitleg:
      "Vink ze aan bij het boekje waar ze in horen. Horen ze bewust in geen enkel boekje? Laat ze dan staan.",
    /** A dag with no organiserend korps has no plaats to name, so name that instead. */
    zonderKorps: "organiserend korps nog niet bekend",
  },

  detail: {
    /** A boekje can vanish under you; this beats a pane of buttons that all fail. */
    weg: "Dit wedstrijdboekje bestaat niet meer. Iemand anders heeft het verwijderd, of de link is verouderd.",
  },

  form: {
    naam: "Naam",
    naamUitleg:
      'Kort, zoals je het boekje onderling noemt: "Halve finales". De naam komt ook in de bestandsnaam terug.',
    naamPlaceholder: "Halve finales",
    titel: "Titel op de omslag",
    titelPlaceholder: "Wedstrijdprogramma halve finales 2027",
    voettekst: "Voettekst",
    voettekstUitleg:
      "De tweede regel onderaan elke pagina. In de boekjes staat die klein.",
    voettekstPlaceholder: "Wedstrijdprogramma halve finales 2027",
    staandeTekst: "Met de vaste hoofdstukken",
    staandeTekstUitleg:
      "Het voorwoord, de inhoudsopgave, fairplay en het reglement. Alleen het seizoensboekje heeft deze hoofdstukken. Een finalesboekje bevat een omslag, de dagen en de documentversies.",
    wedstrijddagen: "Wedstrijddagen",
    geenDagen: "Dit seizoen heeft nog geen wedstrijddagen.",
    dagRegel: "{{niveau}} · {{korps}}",
    dagZonderKorps: "{{niveau}} · organiserend korps nog niet bekend",
    klassen: "Klassen",
    alleKlassen: "Alle klassen die deze dagen hebben",
    alleKlassenUitleg:
      "Beperk je tot bepaalde klassen als dezelfde dag in twee boekjes staat. Bruinisse heeft in het finalesboekje bijvoorbeeld drie klassen en in het Brandbestrijdingsboekje één.",
    opslaan: "Wedstrijdboekje opslaan",
  },

  versies: {
    titel: "Versies",
    uitleg:
      "Elke versie schrijft zichzelf in de documentversies achterin het boekje. De datum op de omslag is de dag waarop je de versie maakt.",
    maken: "Nieuwe versie maken",
    bezigMaken: "Bezig met maken…",
    wijzigingen: "Er zijn wijzigingen sinds de laatste versie.",
    geenWijzigingen: "Er is niets veranderd sinds de laatste versie.",
    watErVerandert: "Wat er in de documentversies komt te staan: {{regel}}",
    eersteVersie: "Dit wedstrijdboekje heeft nog geen versie.",
    geen: "Nog geen versie gemaakt.",
    versie: "Versie {{nummer}}",
    bezig: "Bezig",
    geslaagd: "Klaar",
    mislukt: "Mislukt",
    concept: "Concept",
    downloadPdf: "PDF",
    downloadDocx: "Word",
    /** Reversed from the boekje: the newest on top, because that is the one you download. */
    terugdraaien: "Nieuwste versie terugdraaien",
    terugdraaienVraag: "Versie {{nummer}} terugdraaien?",
    terugdraaienUitleg:
      "De PDF, het Word-bestand en de regel in de documentversies gaan samen weg. Alleen de nieuwste versie kan terug. Elke regel beschrijft wat er sinds de vorige versie veranderde. Haal je een versie uit het midden weg? Dan verwijst de volgende regel naar iets wat er niet meer is.",
    terugdraaienConfirm: "Versie terugdraaien",
  },

  sjabloon: {
    bestand: "Wedstrijdboekje-sjabloon",
    bestandType: "Word-document (.docx)",
    download: "Sjabloon downloaden",
    uploaden: "Ander sjabloon uploaden",
    bezigUploaden: "Bezig met uploaden…",
    geupload: "Het sjabloon is vervangen.",
  },

  verwijderen: {
    titel: "Wedstrijdboekje verwijderen",
    uitleg:
      "Het boekje en alle documenten die het ooit heeft opgeleverd, gaan weg. De wedstrijddagen zelf blijven staan.",
    vraag: "{{naam}} verwijderen?",
    beschrijving:
      "Ook elke versie en elk bestand dat erbij hoort, verdwijnt. Je kunt dit niet ongedaan maken.",
    confirm: "Wedstrijdboekje verwijderen",
  },

  errors: {
    ophalen: "Kon de wedstrijdboekjes niet ophalen.",
    aanmaken: "Kon het wedstrijdboekje niet aanmaken.",
    opslaan: "Kon het wedstrijdboekje niet opslaan.",
    verwijderen: "Kon het wedstrijdboekje niet verwijderen.",
    genereren: "Kon de versie niet maken.",
    versieWeg: "Kon de versie niet terugdraaien.",
    sjabloonUploaden: "Kon het sjabloon niet uploaden.",
  },
} as const;
